export default __webpack_public_path__ + "static/media/border-white.5442a13d.svg";